/* Sweet Offroad — Show Install Booking (parts come from the customer's cart) */
(function () {
  'use strict';

  function parseTime(t) {
    // "9:00 AM", "10 AM", "1:30pm", "13:00" -> minutes after midnight, or null
    var m = String(t || '').trim().match(/^(\d{1,2})(?::(\d{2}))?\s*([AaPp][Mm])?$/);
    if (!m) return null;
    var h = parseInt(m[1], 10), min = m[2] ? parseInt(m[2], 10) : 0, ap = m[3] ? m[3].toLowerCase() : null;
    if (ap === 'pm' && h < 12) h += 12;
    if (ap === 'am' && h === 12) h = 0;
    return h * 60 + min;
  }

  function fmtTime(mins) {
    var h = Math.floor(mins / 60) % 24, m = mins % 60, ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Cart update failed');
        return j;
      });
    });
  }

  function Booking(root) {
    this.root = root;
    this.$ = function (s) { return root.querySelector(s); };
    this.data = JSON.parse(root.querySelector('[data-booking-json]').textContent);
    this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.data.currency || 'USD' });
    this.items = (this.data.cart || []).map(function (it) {
      it.installable = it.hours !== null && it.hours !== undefined && Number(it.hours) > 0;
      return it;
    });
    this.selected = {};      // cart line key -> true
    var self = this;
    this.items.forEach(function (it) { if (it.installable) self.selected[it.key] = true; });
    this.day = null;
    this.start = null;       // index into this.days[day]
    this.buildDays();

    if (this.isClosed()) {
      this.$('[data-closed]').hidden = false;
      this.$('[data-open]').hidden = true;
      return;
    }
    this.renderParts();
    this.renderDays();
    this.bindFields();
    this.$('[data-submit]').addEventListener('click', this.submit.bind(this));
    this.update();
  }

  Booking.prototype.isClosed = function () {
    var c = this.data.bookingCloses;
    if (c) {
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var close = new Date(c + 'T23:59:59');
      if (today > close) return true;
    }
    return !this.data.slots.some(function (s) { return s.available; });
  };

  Booking.prototype.buildDays = function () {
    var days = {}, order = [];
    this.data.slots.forEach(function (s) {
      var mins = parseTime(s.time);
      if (mins === null) return;
      if (!days[s.day]) { days[s.day] = []; order.push(s.day); }
      days[s.day].push({ id: s.id, mins: mins, available: s.available, price: s.price });
    });
    order.forEach(function (d) { days[d].sort(function (a, b) { return a.mins - b.mins; }); });
    this.days = days;
    this.dayOrder = order;
  };

  Booking.prototype.selectedItems = function () {
    var sel = this.selected;
    return this.items.filter(function (it) { return it.installable && sel[it.key]; });
  };

  Booking.prototype.hoursNeeded = function () {
    var total = this.selectedItems().reduce(function (t, it) { return t + Number(it.hours) * it.qty; }, 0);
    return total > 0 ? Math.ceil(total - 1e-9) : 0;
  };

  // Can a job of n hours start at index i of this day's slots?
  Booking.prototype.fits = function (slots, i, n) {
    if (!n) return false;
    for (var k = 0; k < n; k++) {
      var s = slots[i + k];
      if (!s || !s.available) return false;
      if (k > 0 && s.mins - slots[i + k - 1].mins !== 60) return false;
    }
    return true;
  };

  Booking.prototype.label = function (it) {
    return it.title + (it.variantTitle ? ' (' + it.variantTitle + ')' : '') + (it.qty > 1 ? ' ×' + it.qty : '');
  };

  Booking.prototype.renderParts = function () {
    var wrap = this.$('[data-parts]'), self = this;
    var installable = this.items.filter(function (it) { return it.installable; });
    var others = this.items.filter(function (it) { return !it.installable; });

    if (!installable.length) {
      this.$('[data-parts-empty]').hidden = false;
      this.$('[data-parts-hint]').hidden = true;
      if (others.length) {
        this.$('[data-empty-text]').textContent =
          'The parts in your cart aren’t ones we install at shows. Add an install-ready part to your cart, or email us and we’ll see if we can fit it in.';
      }
    }

    this.items.forEach(function (it) {
      var card = document.createElement('div');
      card.className = 'so-part' + (it.installable ? ' is-selected' : ' is-out');
      var chip = it.installable
        ? '<span class="so-chip">~' + esc(Number(it.hours) * it.qty) + ' hr install</span>'
        : '<span class="so-chip so-chip--muted">Not installed at shows</span>';
      card.innerHTML =
        (it.image ? '<img class="so-part__img" src="' + esc(it.image) + '" alt="" loading="lazy" width="120" height="120">' : '<div class="so-part__img"></div>') +
        '<div class="so-part__body">' +
          '<a class="so-part__name" href="' + esc(it.url) + '" target="_blank" rel="noopener">' + esc(it.title) + '</a>' +
          '<div class="so-part__meta">' + chip +
            (it.variantTitle ? '<span>' + esc(it.variantTitle) + '</span>' : '') +
            '<span>Qty ' + esc(it.qty) + '</span><span>' + self.money.format(it.price / 100) + '</span></div>' +
        '</div>' +
        (it.installable ? '<button type="button" class="so-part__toggle" aria-pressed="true">Install ✓</button>' : '');
      var btn = card.querySelector('button');
      if (btn) {
        btn.addEventListener('click', function () {
          if (self.selected[it.key]) delete self.selected[it.key]; else self.selected[it.key] = true;
          var on = !!self.selected[it.key];
          card.classList.toggle('is-selected', on);
          btn.setAttribute('aria-pressed', on);
          btn.textContent = on ? 'Install ✓' : 'Install';
          self.start = null;   // job length may have changed
          self.update();
        });
      }
      wrap.appendChild(card);
    });
  };

  Booking.prototype.renderDays = function () {
    var wrap = this.$('[data-days]'), self = this;
    this.dayOrder.forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'so-day'; b.textContent = d;
      b.setAttribute('role', 'tab');
      b.addEventListener('click', function () { self.day = d; self.start = null; self.update(); });
      wrap.appendChild(b);
    });
    var firstOpen = this.dayOrder.filter(function (d) { return self.days[d].some(function (s) { return s.available; }); })[0];
    this.day = firstOpen || this.dayOrder[0];
  };

  Booking.prototype.renderTimes = function () {
    var wrap = this.$('[data-times]'), self = this, n = this.hoursNeeded();
    wrap.innerHTML = '';
    var slots = this.days[this.day] || [];
    this.root.querySelectorAll('.so-day').forEach(function (b) {
      var on = b.textContent === self.day;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on);
    });
    slots.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      var ok = self.fits(slots, i, n);
      var state = !s.available ? 'booked' : (n && !ok ? 'short' : 'open');
      b.className = 'so-time so-time--' + state;
      b.disabled = !n || !ok;
      b.textContent = fmtTime(s.mins);
      if (state === 'booked') b.title = 'Booked';
      if (state === 'short') b.title = 'Not enough back-to-back time for a ' + n + '-hour job';
      if (self.start !== null && i >= self.start && i < self.start + n) b.classList.add('is-picked');
      b.addEventListener('click', function () { self.start = i; self.update(); });
      wrap.appendChild(b);
    });
  };

  Booking.prototype.bindFields = function () {
    var self = this;
    this.root.querySelectorAll('.so-fields input, .so-fields select, .so-fields textarea').forEach(function (el) {
      el.addEventListener('input', function () { self.update(); });
      el.addEventListener('change', function () { self.update(); });
    });
  };

  Booking.prototype.field = function (name) {
    var el = this.root.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  };

  Booking.prototype.jeepOk = function () {
    return /^(19|20)\d{2}$/.test(this.field('jeep_year')) && this.field('jeep_model') && this.field('jeep_trim');
  };

  Booking.prototype.pickedSlots = function () {
    if (this.start === null) return [];
    var slots = this.days[this.day] || [], n = this.hoursNeeded();
    if (!this.fits(slots, this.start, n)) return [];
    return slots.slice(this.start, this.start + n);
  };

  // "Parts Deposit" product: one variant per $5 from $5 to $5,000.
  // Variant IDs were created in runs where each next $5 step is +32768.
  // [first amount, last amount, ID of first amount] (dollars). The cart response is checked
  // against the expected price, so a wrong lookup can never charge the wrong amount.
  var DEPOSIT_RUNS = [
    [5, 5, 44615684161614], [10, 100, 44615684718670], [105, 200, 44615685505102],
    [205, 500, 44615686291534], [505, 1000, 44615688421454], [1005, 1500, 44615694581838],
    [1505, 2000, 44615698153550], [2005, 2500, 44615701921870], [2505, 3000, 44615705362510],
    [3005, 3500, 44615709261902], [3505, 4000, 44615712735310], [4005, 4500, 44615716798542],
    [4505, 5000, 44615721320526]
  ];
  var DEPOSIT_STEP = 500, DEPOSIT_MAX = 500000;   // cents
  function depositVariant(cents) {
    var dollars = cents / 100;
    for (var i = 0; i < DEPOSIT_RUNS.length; i++) {
      var r = DEPOSIT_RUNS[i];
      if (dollars >= r[0] && dollars <= r[1]) return r[2] + ((dollars - r[0]) / 5) * 32768;
    }
    return null;
  }
  // Split a deposit (multiple of $5) into lines of at most $5,000 each.
  function depositLines(cents) {
    var lines = [];
    while (cents > DEPOSIT_MAX) { lines.push(DEPOSIT_MAX); cents -= DEPOSIT_MAX; }
    if (cents > 0) lines.push(cents);
    return lines;
  }

  // Money math, all in cents.
  Booking.prototype.money_ = function (parts, picked) {
    var d = this.data;
    var mode = d.chargePartsNow ? 'full' : ((d.partsDepositPct > 0 && d.partsDepositVariant) ? 'deposit' : 'event');
    var partsTotal = parts.reduce(function (t, it) { return t + it.price; }, 0);
    var slotDep = picked.reduce(function (t, s) { return t + s.price; }, 0);
    var partsToday = 0;
    if (mode === 'full') partsToday = partsTotal;
    if (mode === 'deposit' && partsTotal > 0) {
      partsToday = Math.ceil((partsTotal * d.partsDepositPct / 100) / DEPOSIT_STEP - 1e-9) * DEPOSIT_STEP;
      if (partsToday > partsTotal) partsToday = Math.floor(partsTotal / DEPOSIT_STEP) * DEPOSIT_STEP;
    }
    var labor = d.laborRate ? d.laborRate * picked.length : null;
    return {
      mode: mode, partsTotal: partsTotal, slotDep: slotDep, partsToday: partsToday,
      depLines: mode === 'deposit' ? depositLines(partsToday) : [],
      today: slotDep + partsToday, partsBal: partsTotal - partsToday,
      laborTotal: labor, laborBal: labor === null ? null : Math.max(0, labor - slotDep)
    };
  };

  Booking.prototype.update = function () {
    var n = this.hoursNeeded(), parts = this.selectedItems(), picked = this.pickedSlots(), self = this;
    if (picked.length === 0) this.start = null;
    this.renderTimes();

    this.$('[data-slot-hint]').textContent = n
      ? 'Your parts need about ' + n + ' hour' + (n > 1 ? 's' : '') + '. Pick a start time; we\'ll hold ' + (n > 1 ? n + ' back-to-back blocks' : 'that hour') + '.'
      : 'Choose parts to install first to see open times.';

    var others = this.items.filter(function (it) { return !it.installable || !self.selected[it.key]; });
    var note = [];
    var mm = this.money_(parts, picked);
    if (parts.length && mm.mode === 'deposit') note.push('Parts you install move from your cart into this booking. You pay a ' + this.data.partsDepositPct + '% parts deposit today and the rest at the event.');
    if (parts.length && mm.mode === 'event') note.push('Parts you install move from your cart into this booking. You pay for them at the event.');
    if (others.length) note.push(others.length + ' other item' + (others.length > 1 ? 's stay' : ' stays') + ' in your cart and ship' + (others.length > 1 ? '' : 's') + ' as usual.');
    var noteEl = this.$('[data-parts-note]');
    noteEl.textContent = note.join(' ');
    noteEl.hidden = !note.length || !this.items.some(function (it) { return it.installable; });

    this.$('[data-sum-parts]').textContent = parts.length ? parts.map(function (it) { return self.label(it); }).join(', ') : 'None yet';
    this.$('[data-sum-hours]').textContent = n ? n + ' hr' + (n > 1 ? 's' : '') : '—';
    this.$('[data-sum-slot]').textContent = picked.length
      ? this.day + ', ' + fmtTime(picked[0].mins) + ' – ' + fmtTime(picked[picked.length - 1].mins + 60)
      : '—';
    var f = function (c) { return self.money.format(c / 100); };
    var show = function (sel, on) { self.$(sel).hidden = !on; };
    show('[data-money]', parts.length > 0 && picked.length > 0);
    if (parts.length && picked.length) {
      this.$('[data-m-slot-label]').textContent = 'Install slot deposit (' + picked.length + ' hr' + (picked.length > 1 ? 's' : '') + ')';
      this.$('[data-m-slot]').textContent = f(mm.slotDep);
      show('[data-m-parts-row]', mm.mode !== 'event');
      this.$('[data-m-parts-label]').textContent = mm.mode === 'full' ? 'Parts' : 'Parts deposit (' + this.data.partsDepositPct + '%)';
      this.$('[data-m-parts]').textContent = f(mm.partsToday);
      this.$('[data-m-today]').textContent = f(mm.today);
      show('[data-m-pbal-row]', mm.partsBal > 0);
      this.$('[data-m-pbal]').textContent = f(mm.partsBal);
      show('[data-m-lbal-row]', mm.laborBal !== null);
      show('[data-m-lnote-row]', mm.laborBal === null);
      if (mm.laborBal !== null) {
        this.$('[data-m-lbal-label]').textContent = 'Labor balance (est. ' + picked.length + ' hr × ' + f(this.data.laborRate) + ')';
        this.$('[data-m-lbal]').textContent = f(mm.laborBal);
      }
    }

    var steps = [parts.length > 0, picked.length > 0, !!this.jeepOk(), false];
    var active = steps.indexOf(false);
    this.root.querySelectorAll('[data-step-label]').forEach(function (li, i) {
      li.classList.toggle('is-done', steps[i]);
      li.classList.toggle('is-active', i === active);
    });
    this.$('[data-submit]').disabled = !(parts.length && picked.length && this.jeepOk());
  };

  Booking.prototype.submit = function () {
    var btn = this.$('[data-submit]'), err = this.$('[data-error]'), self = this;
    var parts = this.selectedItems(), picked = this.pickedSlots();
    if (!parts.length || !picked.length || !this.jeepOk()) return;
    err.hidden = true;
    btn.disabled = true; btn.textContent = 'Booking…';

    var bookingId = 'SO-' + Date.now().toString(36).toUpperCase();
    var slotText = this.day + ', ' + fmtTime(picked[0].mins) + ' – ' + fmtTime(picked[picked.length - 1].mins + 60);
    var partsText = parts.map(function (it) { return self.label(it); }).join('; ');
    var jeep = [this.field('jeep_year'), this.field('jeep_model'), this.field('jeep_trim')].join(' ');
    var mm = this.money_(parts, picked);
    var f = function (c) { return self.money.format(c / 100); };

    var items = picked.map(function (s, k) {
      var props = { 'Booking ID': bookingId, 'Block': (k + 1) + ' of ' + picked.length };
      if (k === 0) {
        props['Install time'] = slotText;
        props['Parts'] = partsText;
        props['Parts total'] = f(mm.partsTotal);
        if (mm.mode !== 'full') props['Parts balance due at event'] = f(mm.partsBal);
        if (mm.laborBal !== null) props['Est. labor balance due at event'] = f(mm.laborBal);
        props['Jeep'] = jeep;
        if (self.field('jeep_mods')) props['Existing mods'] = self.field('jeep_mods');
        if (self.field('notes')) props['Notes'] = self.field('notes');
        props['_install_hours'] = String(picked.length);
        props['_part_variants'] = parts.map(function (it) { return it.variantId + 'x' + it.qty; }).join(',');
      }
      return { id: s.id, quantity: 1, properties: props };
    });
    var expectDeposit = {};   // variant id -> expected price (cents)
    for (var di = 0; di < mm.depLines.length; di++) {
      var vid = depositVariant(mm.depLines[di]);
      if (!vid) {
        err.textContent = 'We couldn’t set up the parts deposit for this amount. Please email us to book this install.';
        err.hidden = false; btn.disabled = false; btn.textContent = 'Book & pay deposit';
        return;
      }
      expectDeposit[vid] = mm.depLines[di];
      items.push({
        id: vid, quantity: 1,
        properties: {
          'Booking ID': bookingId,
          'Deposit': this.data.partsDepositPct + '% of ' + f(mm.partsTotal) + ' in parts',
          'For': partsText
        }
      });
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    // 1) add the time slots (fails cleanly if a slot was just taken; nothing else has changed yet)
    postJSON(root + 'cart/add.js', { items: items })
      .then(function (added) {
        // Safety check: every deposit line must carry exactly the expected price.
        var lines = (added && added.items) || [];
        var bad = lines.filter(function (l) {
          return expectDeposit.hasOwnProperty(l.variant_id) && l.price !== expectDeposit[l.variant_id];
        });
        if (bad.length) {
          var undo = {};
          lines.forEach(function (l) { undo[l.key] = 0; });
          return postJSON(root + 'cart/update.js', { updates: undo }).then(function () {
            throw new Error('deposit amount mismatch');
          });
        }
      })
      .then(function () {
        if (mm.mode !== 'full') {
          // 2a) move the installed parts out of the cart; they are recorded on the booking
          var updates = {};
          parts.forEach(function (it) { updates[it.key] = 0; });
          return postJSON(root + 'cart/update.js', { updates: updates });
        }
        // 2b) keep the parts in the cart, tagged with the booking
        return parts.reduce(function (p, it) {
          return p.then(function () {
            return postJSON(root + 'cart/change.js', {
              id: it.key, quantity: it.qty,
              properties: { 'Booking ID': bookingId, 'Install at': self.data.eventTitle }
            });
          });
        }, Promise.resolve());
      })
      .then(function () {
        window.location.href = root + (self.data.afterAdd === 'cart' ? 'cart' : 'checkout');
      })
      .catch(function (e) {
        err.textContent = 'Something went wrong booking that time. It may have just been taken. Please refresh the page and try again, and check your cart before checking out. (' + e.message + ')';
        err.hidden = false;
        btn.disabled = false; btn.textContent = 'Book & pay deposit';
      });
  };

  function init() {
    document.querySelectorAll('.so-booking[data-section]').forEach(function (el) {
      if (!el.__soBooking && el.querySelector('[data-booking-json]')) el.__soBooking = new Booking(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.SOBooking = { parseTime: parseTime, fmtTime: fmtTime };
})();
